import React from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import '@meilleurtaux/mtp-uikit-core/dist/styles/tokens.min.css';
import '@meilleurtaux/mtx-totem-icons/dist/totem-icons.css';

import App from '@/App';
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import Providers from '@/components/Providers/Providers';

import './global.css';

datadogRum.init({
  applicationId: import.meta.env.VITE_DD_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
  site: 'datadoghq.eu',
  service: 'placement-espace-client-frontend',
  env: import.meta.env.VITE_DD_ENV_NAME,
  version: APP_VERSION,
  sessionSampleRate: Number(import.meta.env.VITE_DD_SAMPLE_RATE),
  sessionReplaySampleRate: Number(import.meta.env.VITE_DD_REPLAY_SAMPLE_RATE),
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: [{ match: import.meta.env.VITE_API_BASE_URL, propagatorTypes: ['tracecontext'] }],
  plugins: [reactPlugin({ router: false })],
});

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <Providers>
        <App />
      </Providers>
    ),
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </React.StrictMode>
);
